import { locationIdFormat } from "@redotech/redo-ids-cockroach";
import * as z from "zod";

export const createConsolidationFulfillmentGroup = {
  name: "createConsolidationFulfillmentGroup" as const,
  input: z.object({
    teamId: z.string(),
    originLocationId: locationIdFormat.schema,
  }),
  output: z.object({ fulfillmentGroupId: z.string() }),
};
